<template>
    <v-dialog
    v-model="show"
    persistent
    width="570">
   
    <v-card color="light_gray">
        <v-toolbar class="mid-font" color="primary" dense dark >
            <v-icon left >mdi-gamepad-circle-up</v-icon><span class="va-underline">{{state=='new'?'Open':'Update'}} {{game}} Draw</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4 def-font">
               <v-form
                ref="form"
                autocomplete="off"
                v-model="valid"
                lazy-validation>
                    <v-row dense>
                         <v-col cols="6">
                            <v-text-field
                                v-model="entry.draw_seq"
                                label="No. Draw to be generate"
                                filled
                                type="number"
                                outlined
                                dense
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                v-model="entry.draw_interval"
                                label="Draw Interval (per minute)"
                                :items="[2,5,10,15,20,30]"
                                filled
                                outlined
                                dense
                                :rules="nameRules"
                                required
                            ></v-autocomplete>
                        </v-col>
                        
                        <v-col cols="6">
                             <v-text-field
                             type="number"
                                v-model="entry.winning_amount"
                                label="Wining Amount Per Unit"
                                filled
                                
                                outlined
                                dense
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                             <v-text-field
                                v-model="entry.payout_percent"
                                label="Payout Percentage"
                                outlined
                                dense
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                                <v-text-field
                                type="number"
                                v-model="entry.fund"
                                label="Funding"
                                    outlined
                                dense
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                v-model="entry.status"
                                :items="['Open', 'Close', 'Ready', 'Void']"
                                label="Status"
                                :rules="nameRules"
                                    required
                                    outlined
                                    dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                   
               </v-form>
               <v-divider/>
          </v-card-text>
          <v-card-actions>
              <v-btn text small color="warning" @click="emitToParent('close')">
                 close
              </v-btn>
              <v-spacer/>
              <v-btn small text color="success" :loading="loading" @click="validate()">
                 Ok
              </v-btn>
          </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
       state: {
          type: String,
          default: 'new'
      },
      game: {
          type: String,
          default: ''
      },
      item: {
          type: Object,
          default:()=>{}
      }
  },
  data () {
      return {
          menu1: false,
          menu2: false,
          loading: false,
          selected_draw:{},
          selected_draw_date: '',
          draw_time:'',
          valid: true,
          entry:{},
           nameRules: [
            v => !!v || '*Required'
        ],
      }
    },
  watch: {
     show(val) {
         if(val) {
             this.entry = {}
            if(this.state == 'new') {
             this.entry.game = this.GAMESETTING.game
             this.entry.status = "Close"
             this.entry.winning_amount = this.GAMESETTING.winning_amount
             this.entry.fund = this.GAMESETTING.fund
             this.entry.payout_percent = this.GAMESETTING.payout_percent
            } else {
                this.entry = this.item
                this.selected_draw = {time: this.entry.time, draw_seq: this.entry.draw_seq}
            }
         }
     }
  },
  computed:{
      DRAW_SEQ(){
          if(this.$store.state.game_setting.Draws == undefined) {
                return []
          }
          var draws = []
          for (var i = 0;i<this.$store.state.game_setting.Draws.length;i++) {
                draws.push({draw_seq:"draw " + (i+1), time:this.$store.state.game_setting.Draws[i]})
          }
          
           return draws
      },
      GAMESETTING(){
          return this.$store.state.game_setting
      },
    NEXT_DRAW() {
        if(!this.entry.date) {
            return 'No date time selected'
        }
        return this.entry.date + ' ' + this.entry.time
    }
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', {action:action})
    },
    validate(){
        if (this.$refs.form.validate()) {
            this.Save()
        }
    },
    Save(){
        this.loading = true
        this.entry.game = this.game
        this.entry.draw_seq = parseInt(this.entry.draw_seq)
         this.entry.draw_interval = parseInt(this.entry.draw_interval)
        var method = this.state == 'new'?'draw/add':'draw/update'
        console.log( this.entry)
        this.$http.post(method, this.entry).then(response => {
            response.data.status?this.VA_ALERT('success',response.data.message):this.VA_ALERT('error',response.data.message)
       setTimeout(()=>{
             this.loading = false
            this.$emit('DialogEvent', {action:'close'})
       }, 1700)
     
        }).catch(e => {
            console.log(e)
        })
    
    }
  }
}
</script>
